import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-background" data-testid="terms-page">
      {/* Header */}
      <header className="border-b border-border">
        <div className="max-w-3xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="text-xl font-medium tracking-tight font-serif hover:text-accent transition-colors">
            Decided
          </Link>
          <Link to="/login">
            <Button variant="ghost" size="sm">
              Log in
            </Button>
          </Link>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-6 py-20 md:py-28">
        <h1 className="text-3xl md:text-4xl font-medium tracking-tight font-serif text-foreground">
          Terms of Service
        </h1>

        <div className="mt-12 space-y-6 text-muted-foreground leading-relaxed">
          <p className="text-foreground text-lg">
            Decided is provided as-is.
          </p>

          <p>
            You are responsible for the decisions and actions you record in the app.<br />
            Decided is a support tool and does not provide professional, legal, or financial advice.
          </p>

          <p>
            You retain ownership of your content.
          </p>

          <p>
            We may update, modify, or discontinue the service at any time.
          </p>

          <p>
            We may suspend or terminate accounts in cases of misuse.
          </p>

          <p>
            By using Decided, you agree to these terms.
          </p>
        </div>
      </main>

      {/* Footer */}
      <footer className="border-t border-border">
        <div className="max-w-3xl mx-auto px-6 py-8">
          <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm text-muted-foreground">
            <Link to="/pricing" className="hover:text-foreground transition-colors">Pricing</Link>
            <Link to="/why" className="hover:text-foreground transition-colors">Why Decided</Link>
            <Link to="/privacy" className="hover:text-foreground transition-colors">Privacy</Link>
            <Link to="/terms" className="hover:text-foreground transition-colors">Terms</Link>
            <Link to="/contact" className="hover:text-foreground transition-colors">Contact</Link>
            <Link to="/login" className="hover:text-foreground transition-colors">Login</Link>
          </div>
          <p className="mt-6 text-center text-xs text-muted-foreground/50">
            © {new Date().getFullYear()} Decided
          </p>
        </div>
      </footer>
    </div>
  );
}
